import React, { useEffect, useState } from 'react'
import {apiurl,host} from '../../path';
import { Form, useParams } from 'react-router-dom';

const ForgetPageLink = () => {
  let link=useParams()
  const [passwordresetform,setpasswordresetform]=useState({
    password:"",
    confirmpassword:""
  })
  useEffect(() => {
    Checklink()
    return () => {
      
    }
  }, [])
  async function Checklink() {
    try {
      let Forgettoken=await fetch(apiurl+'/VerifyPassword',
      {method:"POST",
      headers:({'Content-Type': 'Application/json',"ForgetToken":link.Link}),
      body:JSON.stringify({type:"verify"})
    })
      Forgettoken= await Forgettoken.json()
     if(Forgettoken)
     {
      alert('Please Enter New Password')
     }else{
      window.location.href='/adminlogin'
     }
      } catch (error) {
        console.error("Error in AdminLogin:", error);
      }
  }
  async function ResetPassword() {
    try {
      let passcheck=passwordresetform.password.toString().length
    if (passcheck>=6&&passwordresetform.password===passwordresetform.confirmpassword) {
      let data = await fetch(apiurl+'/VerifyPassword',{
        method:"POST",
        headers:({"Content-Type":"application/json","ForgetToken":link.Link}),
        body:JSON.stringify({...passwordresetform ,type:"changepassword"})
      })
      data = await data.json()
      if (data) {
        alert("Password Updated")
      } else {
        alert("Password Not Updated")
      }
    } else {
      alert('Password length must be 6 or greater')
    }
    } catch (error) {
      console.error("Error in ResetPassword:", error);
    }
  }
  return (
    <>
    <div style={{backgroundColor:"#f6f8fc",padding:"50px"}}>
            <div style={{ display: "grid" ,border:"2px solid red",borderRadius:"20px",border:"none",padding:"20px",backgroundColor:'white'}}>
                <div style={{ display: 'grid' }}>
                    <div>
                        <h5 className='heading' style={{textAlign:"center"}}><b>Reset Password</b></h5>
                        <Form onSubmit={ResetPassword}>
                          <div class="mb-3">
                            <label for="" class="form-label">Password</label>
                            <input
                              type="password"
                              class="form-control"
                              name=""
                              id="password"
                              onChange={(e)=>setpasswordresetform({...passwordresetform,[e.target.id]:e.target.value})}
                              placeholder=""
                              required
                            />
                          </div>
                          <div class="mb-3">
                            <label for="" class="form-label">Confirm Password</label>
                            <input
                              type="text"
                              class="form-control"
                              name=""
                              id="confirmpassword"
                              onChange={(e)=>setpasswordresetform({...passwordresetform,[e.target.id]:e.target.value})}
                              placeholder=""
                              required
                            />
                          </div>
                          <button className='btn btn-dark'>Reset Password</button>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </>
    
  )
}

export default ForgetPageLink